import script from "./ModalTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalTask.vue?vue&type=script&setup=true&lang=js"

import "./ModalTask.vue?vue&type=style&index=0&id=47e3b964&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e3b964"]])

export default __exports__